// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__WSO0l","left":"StickyBox_left__2FHHF","right":"StickyBox_right__3RgwA"};